import en from '../../lang/en-us';
import { Checkbox, FormControlLabel } from '@material-ui/core';
const { dashboard } = en;

export function CheckBoxField(
    { label = '', onChange = (e: any) => {}, value = false, disabled = false },
    props: any,
) {
    return (
        <FormControlLabel
            control={<Checkbox onChange={onChange} checked={value} disabled={disabled} />}
            label={label}
            disabled={disabled}
        />
    );
}
